import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductSalePageRoutingModule } from './product-sale-routing.module';

import { ProductSalePage } from './product-sale.page';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ProductSalePageRoutingModule,
    NgxIntlTelInputModule
  ],
  declarations: [ProductSalePage]
})
export class ProductSalePageModule {}
